import { FC, memo } from 'react';
import { BreadcrumbItem } from './types';
import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router-dom';
import { toRuntimeTranslationKey } from '@/localization/translationKey';

type BreadcrumbLinkProps = {
  item: BreadcrumbItem;
};

const BreadcrumbLinkComp: FC<BreadcrumbLinkProps> = ({ item }) => {
  const { t } = useTranslation();

  const itemLabel = t(toRuntimeTranslationKey(item.label) as any);
  const itemClasses = 'px-2 py-1 text-sm font-semibold group-last-of-type/breadcrumb:text-brand-600';

  if (item.path) {
    return (
      <NavLink to={item.path} className={itemClasses}>
        {itemLabel}
      </NavLink>
    );
  }

  return <p className={itemClasses}>{itemLabel}</p>;
};

export const BreadcrumbLink = memo(BreadcrumbLinkComp);
